import axios from "axios";

export const PUBLIC_API_KEY_STORAGE = "publicApiKey";

const getPublicApiBaseUrl = () => {
  const backendBase = process.env.REACT_APP_URL_BASE_BACKEND || "";
  if (!backendBase) return "/api/v1";

  return backendBase.replace(/\/api\/?$/i, "/api/v1");
};

class PublicApi {
  constructor() {
    this.api = axios.create({
      baseURL: getPublicApiBaseUrl(),
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.api.interceptors.request.use((config) => {
      const apiKey = localStorage.getItem(PUBLIC_API_KEY_STORAGE);

      if (apiKey) {
        config.headers["x-api-key"] = apiKey;
      }

      return config;
    });
  }

  get(endpoint, config = {}) {
    return this.api.get(endpoint, config);
  }

  post(endpoint, data, config = {}) {
    return this.api.post(endpoint, data, config);
  }
}

const publicApi = new PublicApi();

export default publicApi;
